import { SenecButton } from "@newsenec/ui-components";
import { SenecScreenTemplate } from "../SenecScreenTemplate";
import { useTranslation } from "react-i18next";
import { Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { getUser, logout } from "@newsenec/auth-provider";
import { RegistrationStep } from "./RegistrationScreen";

export const RegistrationConfirmEmail = ({ setRegistrationStep }: { setRegistrationStep: (value: RegistrationStep) => void }) => {
    const { t } = useTranslation();
    const [userEmail, setUserEmail] = useState<string | undefined>();

    useEffect(() => {
        getUser()
            .then((user) => setUserEmail(user?.email))
            .catch(() => {
                /* do nothing */
            });
    }, []);

    return (
        <SenecScreenTemplate
            title={t("registrationScreen.confirmRegistrationData.title")}
            content={
                <>
                    <Typography>{t("registrationScreen.confirmRegistrationData.description")}</Typography>
                    <Typography>{t("registrationScreen.confirmRegistrationData.confirmationPrompt")}</Typography>
                    <Typography fontWeight="bold">{userEmail}</Typography>
                </>
            }
            footer={
                <Stack width="100%" direction="row" justifyContent="space-between" spacing={2}>
                    <SenecButton level="secondary" sx={{ minWidth: "125px" }} onClick={async () => logout()}>
                        {t("registrationScreen.confirmRegistrationData.changeAccount")}
                    </SenecButton>
                    <SenecButton sx={{ minWidth: { xs: "80px", sm: "125px" } }} onClick={() => setRegistrationStep("start")}>
                        {t("registrationScreen.confirmRegistrationData.confirm")}
                    </SenecButton>
                </Stack>
            }
        />
    );
};
